var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarChart = function SvgBarChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 11.333c.46 0 .833.373.833.834v5a.833.833 0 0 1-1.666 0v-5c0-.46.373-.834.833-.834M15 8c.46 0 .833.373.833.833v8.334a.833.833 0 0 1-1.667 0V8.833c0-.46.374-.833.834-.833M10 3c.46 0 .833.373.833.833v13.334a.833.833 0 0 1-1.667 0V3.833c0-.46.374-.833.834-.833",
    clipRule: "evenodd"
  })));
};
export default SvgBarChart;